(function($){
  "use strict";

  const behaviorOptions = {
    name: 'izzyZzzEffect',
    selector: '.zzz-effect',
  };

  const pic = `<svg width="39px" height="45px" viewBox="0 0 39 45" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>z</title>
    <defs>
      <linearGradient x1="30.1165367%" y1="-4.50387203%" x2="177.012432%" y2="223.549027%" id="linearGradient-1">
        <stop stop-color="#716AFF" offset="0%"></stop>
        <stop stop-color="#7CE3FF" offset="37.5426771%"></stop>
        <stop stop-color="#FF9A9A" offset="69.5786669%"></stop>
        <stop stop-color="#FFFEEC" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="izzy_about" transform="translate(-831.000000, -1853.000000)" fill="url(#linearGradient-1)">
        <g id="Group-13" transform="translate(595.000000, 1853.000000)">
           <polygon id="z" points="236 44.1561015 236 37.0430894 262.281194 8.22153355 237.524217 8.22153355 237.524217 0 274.890625 0 274.890625 7.06682378 248.101358 35.934568 274.890625 35.934568 274.890625 44.1561015"></polygon>
        </g>
      </g>
    </g>
  </svg>`;

  function behavior(context, settings) {
    $(once(behaviorOptions.name, behaviorOptions.selector, context)).each(function(index, element) {
      $(function() {
        new IzzyZzzEffect(element, pic);
      });
    });
  }

  Drupal.behaviors[behaviorOptions.name] = {
    attach: function(context, settings){
      behavior(context, settings);
    },
  }

  // Init self in case we are loaded async.
  if (jQuery.isReady) {
    // It is up to script to define scope and settings it should be applied to
    // in case of jquery mobile integration used you can use site_common.jquery_mobile.getPageContext()
    // to get only current page's context.
    // In this example we use global scope.
    const context = document;
    const settings = Drupal.settings;
    Drupal.behaviors[behaviorOptions.name].attach(context, settings);
  }

  class IzzyZzzEffect {
    constructor(containerElement, picMarkup) {
      this.container = containerElement;
      this.pic = picMarkup;
      this.activeClass = 'zzz-effect--active';
      this.hide();
      this.init();
    }

    init() {
      this.addPics(4);
      this.container.addEventListener('mouseenter', this.show.bind(this));
      this.container.addEventListener('mouseleave', this.hide.bind(this));
    }

    show() {
      this.container.classList.add('zzz-effect--active');
    }

    hide() {
      this.container.classList.remove('zzz-effect--active');
    }

    addPics(count) {
      let element;

      for (let i = 0; i < count; i++) {
        element = document.createElement('span');
        element.innerHTML = this.pic;
        element.className = `zzz-effect__item zzz-effect__item--${i}`;
        this.container.appendChild(element);
      }
    }
  }
})(jQuery);
